import { ColorEnum } from '@/constants/color'
import ChevronDownIconComponent from '@/features/ui/icons/components/ChevronDownIcon'
import { FC } from 'react'

const ChevronDownIcon: FC = () => {
    return <ChevronDownIconComponent height={16} width={16} color={ColorEnum.GRAY_400} />
}

export default ChevronDownIcon
